import request from "../Utils/request";

export function getData(url) {
  return request.get(url);
}
